import Vue from 'vue'
import App from './App.vue'
import router from './router'
import bulma from 'bulma'
import VueDragDrop from 'vue-drag-drop';
//import VueWaypoint from 'vue-waypoint'
import * as VueWindow from '@hscmap/vue-window'
import VuejsClipper from 'vuejs-clipper'
import VeeValidate from 'vee-validate';
import linkify from 'vue-linkify'
import VTooltip from 'v-tooltip'
import VueTimeago from 'vue-timeago'
import VueTour from 'vue-tour'


require('vue-tour/dist/vue-tour.css')


import sass from '@/assets/main.sass'






function checkPwd(p) {
	if (p == 'organized$1') {
		return true
	}
	return false
}

function askForPassword() {
	var local = localStorage.getItem('tok');
	if (local == undefined) {
		let newPassword = prompt('Access:');
		if (checkPwd(newPassword)) {
			localStorage.setItem('tok', newPassword);
			return
		} else {
			askForPassword()
		}
	} else {
		if (checkPwd(local)) {
			return
		} else {
			localStorage.setItem('tok', 'noAccess');
			let newPassword = prompt('Access:');
			if (checkPwd(newPassword)) {
				localStorage.setItem('tok', newPassword);
				return
			} else {
				askForPassword()
			}
		}
	}
}
//askForPassword(); //only for non prod evnironments

Vue.use(VeeValidate);
Vue.config.productionTip = false

Vue.directive('linkified', linkify)
Vue.use(VTooltip, {defaultDelay: 500})

Vue.use(VueTour)

Vue.use(VueTimeago, {
	name: 'Timeago', // Component name, `Timeago` by default
	locale: 'en', // Default locale
	// We use `date-fns` under the hood
	// So you can use all locales from it
	locales: {
	  'zh-CN': require('date-fns/locale/zh_cn'),
	  ja: require('date-fns/locale/ja')
	}
  })






const app = new Vue({
  router,
  render: h => h(App),
  data: {
      app: {}
  },
  mounted: function(){
   this.app = this.$children[0]
  }
}).$mount('#app')

Vue.use(VueDragDrop);
Vue.use(VuejsClipper ,{
    components: {
        clipperBasic: true,
        clipperPreview: true
    }
})





//Vue.use(VueWaypoint)
Vue.use(VueWindow)




window.app = app

// Handle burger visibility and trigger
/* document.addEventListener('DOMContentLoaded', function () {
	// Get all "navbar-burger" elements
	var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0)

	// Check if there are any navbar burgers
	if ($navbarBurgers.length > 0) {
		// Add a click event on each of them
		$navbarBurgers.forEach(function ($el) {
			$el.addEventListener('click', function () {
				// Get the target from the "data-target" attribute
				var target = $el.dataset.target
				var $target = document.getElementById(target)

				// Toggle the class on both the "navbar-burger" and the "navbar-menu"
				$el.classList.toggle('is-active')
				$target.classList.toggle('is-active')
				
			})
		})
	}
}) */

document.addEventListener("message", function(data) {

	app.app.tebi = 'yes'
  });

//POLYFILLS
if (!Array.prototype.find) {
	Object.defineProperty(Array.prototype, 'find', {
	  value: function(predicate) {
	   // 1. Let O be ? ToObject(this value).
		if (this == null) {
		  throw new TypeError('"this" is null or not defined');
		}
  
		var o = Object(this);
  
		// 2. Let len be ? ToLength(? Get(O, "length")).
		var len = o.length >>> 0;
  
		// 3. If IsCallable(predicate) is false, throw a TypeError exception.
		if (typeof predicate !== 'function') {
		  throw new TypeError('predicate must be a function');
		}
  
		// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
		var thisArg = arguments[1];
  
		// 5. Let k be 0.
		var k = 0;
  
		// 6. Repeat, while k < len
		while (k < len) {
		  // a. Let Pk be ! ToString(k).
		  // b. Let kValue be ? Get(O, Pk).
		  // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
		  // d. If testResult is true, return kValue.
		  var kValue = o[k];
		  if (predicate.call(thisArg, kValue, k, o)) {
			return kValue;
		  }
		  // e. Increase k by 1.
		  k++;
		}
  
		// 7. Return undefined.
		return undefined;
	  },
	  configurable: true,
	  writable: true
	});
}

Array.prototype.diff = function(a) {
    return this.filter(function(i) {return a.indexOf(i) < 0;});
};

/* import {polyfill} from "mobile-drag-drop";

// optional import of scroll behaviour
//import {scrollBehaviourDragImageTranslateOverride} from "mobile-drag-drop/scroll-behaviour";

// options are optional ;)
polyfill({
    // use this to make use of the scroll behaviour
	//dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride
	holdToDrag: .5
});

window.addEventListener( 'touchmove', function() {}); */





